import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./BranchFile.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import { loaderOverlay } from "../../../Style/loaderOverly.js";

const BranchCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const schema = localStorage.getItem('schema')
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countrySelectOptions, setCountrySelectOptions] = useState([])

  const [selectedState, setSelectedState] = useState(null);
  const [stateSelectOptions, setStateSelectOptions] = useState([])

  const [selectedCity, setSelectedCity] = useState(null);
  const [citySelectOptions, setCitySelectOptions] = useState([])

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);




  useEffect(() => {
    getCountryData()
  }, [])


  const getEditData = async (id) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      }

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data })
        setSelectedCountry({ value: data?.country_id, label: data?.country?.country_name })
        getStateData(data?.country_id)
        setSelectedState({ value: data?.state_id, label: data?.state?.state_name })
        getCityData(data?.state_id)
        setSelectedCity({ value: data?.city_id, label: data?.city?.city_name })
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getCountryData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "country_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.country_name
      }));
      setCountrySelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const getStateData = async (countryId) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "state_masters",
        whereCondition: {
          is_active: true,
          country_id:countryId
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.state_name
      }));
      setStateSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const getCityData = async (stateId) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "city_masters",
        whereCondition: {
          is_active: true,
          state_id:stateId
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.city_name
      }));
      setCitySelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };




  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {

      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleCountrySelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      country_id: selectedValue,
    });

    setSelectedCountry(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      country_id: fieldError?.country_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        country_id: selectedValue,
      },
    }));
    getStateData(options?.value)
  };

  const handleStateSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      state_id: selectedValue,
    });

    setSelectedState(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      state_id: fieldError?.state_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        state_id: selectedValue,
      },
    }));

    getCityData(options?.value)
  };

  const handleCitySelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      city_id: selectedValue,
    });

    setSelectedCity(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      city_id: fieldError?.city_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        city_id: selectedValue,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)
      if (JSON.stringify(validationErrors) !== "{}") return
      // Additional validation for `user_documents`



      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData }

      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData }
      }
      // console.log(payload)
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {

        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // add document



  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="country"
            options={countrySelectOptions}
            value={selectedCountry}
            onSelect={handleCountrySelect}
            placeholder="Select Country"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.country_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="state"
            options={stateSelectOptions}
            value={selectedState}
            onSelect={handleStateSelect}
            placeholder="Select State"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.state_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="city"
            options={citySelectOptions}
            value={selectedCity}
            onSelect={handleCitySelect}
            placeholder="Select City"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.city_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Branch Name"
            name="branch_name"
            value={formData?.inputData?.branch_name}
            onChange={onInputChange}
            placeholder="Branch Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.branch_name}
          />
        </Col>




      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default BranchCreate;
